// ** React Imports
import { useState, useEffect, MouseEvent, useCallback, ReactElement } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import { DataGrid, GridEventListener } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography'
import Icon from 'src/features/common/CustomIcon'
import Link from '@mui/material/Link';
// ** Store Imports
import { SelectOption } from 'src/types/common';
import RefreshTwoToneIcon from '@mui/icons-material/RefreshTwoTone';
// ** Custom Components Imports
import Tooltip from '@mui/material/Tooltip'
import { client } from 'src/utils/axios-client'
import { leadEndpoints } from 'src/configs/endpoints'

import _ from 'lodash'
import CardContent from '@mui/material/CardContent'
import Skeleton from '@mui/material/Skeleton'

import { XYPlot, LineSeries, VerticalGridLines, HorizontalGridLines, XAxis, YAxis, VerticalBarSeries, MarkSeries, DiscreteColorLegend, ChartLabel, HeatmapSeries } from 'react-vis';
import { curveCatmullRom } from 'd3-shape';
import Chip from '@mui/material/Chip';
import { ResponsiveBar } from '@nivo/bar'


type Props = {
    userId: string
}

//type Point = {
//    x: number,
//    y: number
//}
type Point = {
    dayOfWeek: string,
    activity: number,
    mi: number,
    mql: number,
    dc: number,
    opportunity: number
}



const DashboardActivityChart = ({ userId }: Props) => {
    const [reloadRecords, setReloadRecords] = useState<boolean>(false)
    const [dataLoaded, setDataLoaded] = useState<boolean>(false) 
    const [activityData, setActivityData] = useState<Point[]>([])
    const [miData, setMiData] = useState<Point[]>([])
    const [mqlData, setMqlData] = useState<Point[]>([])
    const [dcData, setDcData] = useState<Point[]>([])

    useEffect(() => {
        loadRecords(userId);
    }, [reloadRecords, userId])

    const loadRecords = async (userId: string) => {
        const response = await client.get(leadEndpoints.getdashboardactivitychart, { params: { userId } });
        setActivityData(response.data.activityData);
        //setMiData(response.data.miData);
        //setMqlData(response.data.mqlData);
        //setDcData(response.data.dcData);
        setDataLoaded(true);
    
    }
    
    const BarSeries = VerticalBarSeries;

    const lineGraphSettings = {
        theme: {
            textColor: 'DarkGrey'
        },
    };
    
    if (dataLoaded) {
        return (
            <Grid container spacing={2} justifyContent={'center'}>
                <Grid item xs={12} md={12} sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column', width: '100%' }} >
                    <Card >
                        <Typography sx={{ fontSize: 16, color: 'DarkGrey', ml: 3, mr: 3, width: '100%' }}>
                            Activity Comparison for This Month
                        </Typography>
                    </Card>
                </Grid>
                <Grid item xs={12} md={12} sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column', width: '100%' }} spacing={1}>
                    <Card sx={{ pt: 4, pb: 3 }}>
                        <Grid item xs={12} md={12} alignItems="flex-start">
                            {/*<XYPlot width={1000} height={300} stackBy="y">*/}
                            {/*    <VerticalGridLines />*/}
                            {/*    <HorizontalGridLines />*/}
                            {/*    <XAxis title="Day" style={{ text: { fill: 'DarkGrey' } }} />*/}
                            {/*    <YAxis title="Activities" style={{ text: { fill: 'DarkGrey' } }} />*/}
                            {/*    <BarSeries color='Gray' barWidth={0.4} data={activityData} animation={true} />*/}
                            {/*    <BarSeries color='Blue' barWidth={0.4} data={miData} animation={true} />*/}
                            {/*    <BarSeries color='Orange' barWidth={0.4} data={mqlData} animation={true} />*/}
                            {/*    <BarSeries color='Green' barWidth={0.4} data={dcData} animation={true} />*/}
                            {/*</XYPlot>*/}
                            <div style={{ height: 600 }}>
                            <ResponsiveBar
                                    data={activityData}
                                keys={[
                                    'activity',
                                    'mi',
                                    'mql',
                                    'dc',
                                    'opportunity'
                                ]}
                                indexBy="dayOfWeek"
                                margin={{ top: 50, right: 130, bottom: 100, left: 100 }}
                                padding={0.15}
                                innerPadding={3}
                                valueScale={{ type: 'linear' }}
                                indexScale={{ type: 'band', round: true }}
                                colors={{ scheme: 'dark2' }}
                                borderColor={{
                                    from: 'color',
                                    modifiers: [
                                        [
                                            'darker',
                                            1.6
                                        ]
                                    ]
                                }}
                                axisTop={null}
                                    axisRight={null}
                                    theme={lineGraphSettings.theme}
                                axisBottom={{
                                    tickSize: 5,
                                    tickPadding: 1,
                                    tickRotation: 0,
                                    legend: 'Days of the Month',
                                    legendPosition: 'middle',
                                    legendOffset: 32
                                }}
                                axisLeft={{
                                    tickSize: 5,
                                    tickPadding: 5,
                                    tickRotation: 0,
                                    legend: 'Count',
                                    legendPosition: 'middle',
                                    legendOffset: -40
                                }}
                                labelSkipWidth={12}
                                labelSkipHeight={12}
                                labelTextColor={{
                                    from: 'color',
                                    modifiers: [
                                        [
                                            'darker',
                                            1.6
                                        ]
                                    ]
                                    }}

                                legends={[
                                    {
                                        dataFrom: 'keys',
                                        anchor: 'right',
                                        direction: 'column',
                                        justify: false,
                                        translateX: 120,
                                        translateY: 0,
                                        itemsSpacing: 2,
                                        itemWidth: 100,
                                        itemHeight: 20,
                                        itemDirection: 'left-to-right',
                                        itemOpacity: 0.85,
                                        symbolSize: 20,
                                        effects: [
                                            {
                                                on: 'hover',
                                                style: {
                                                    itemOpacity: 1
                                                }
                                            }
                                        ]
                                    }
                                ]}
                                role="application"
                                tooltip={({ id, value, color }) => (
                                    <div
                                        style={{
                                            padding: 12,
                                            color,
                                            background: '#222222',
                                        }}
                                    >
                                        <strong>
                                            {id}: {value}
                                        </strong>
                                    </div>
                                )}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} alignContent="left">
                            {/*<Grid container spacing={2} sx={{ mb: 4 }} >*/}
                            {/*    <Grid item xs={12} md={12} alignContent="left">*/}
                            {/*        <Tooltip title="Activities that had no meaningful interaction" >*/}
                            {/*            <Chip label="Activities" size="small" sx={{ color: 'Gray' }} />*/}
                            {/*        </Tooltip>*/}
                            {/*        <Tooltip title="Activities that had a meaningful interaction" >*/}
                            {/*            <Chip label="MIs" size="small" sx={{ color: 'Blue' }} />*/}
                            {/*        </Tooltip>*/}
                            {/*        <Tooltip title="Activities that had an MQL" >*/}
                            {/*            <Chip label="MQLs" size="small" sx={{ color: 'Orange' }} />*/}
                            {/*        </Tooltip>*/}
                            {/*        <Tooltip title="Activities that had an Discovery Call" >*/}
                            {/*            <Chip label="DCs" size="small" sx={{ color: 'Green' }} />*/}
                            {/*        </Tooltip>*/}
                            {/*    </Grid>*/}
                            {/*</Grid>*/}
                        </Grid>
                        
                    </Card>
                </Grid>
                
            </Grid>
        )
    }
    else {
        return <Box>
            <Card variant="outlined">
                <CardContent>
                    <Grid item xs={12} md={12} sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <Card >
                            <Skeleton variant="text" sx={{ fontSize: 16, ml: 3, mr: 3 }} width={200} />
                        </Card>
                    </Grid>
                    <Grid container spacing={1} justifyContent={'left'}>
                        <Grid item xs={12} md={12} sx={{ display: 'flex', mb: 0.7, alignItems: 'left' }}>
                            <Skeleton variant="rectangular" width={'100%'} height={300} />
                        </Grid>
                        
                    </Grid>
                </CardContent>

            </Card>

        </Box>
    }

}

export { DashboardActivityChart }
export default DashboardActivityChart
